import React, { ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { libraryParams, normalizeLibraryCode } from "../../types/Library";
import { getInitialDirectRecommendAttempt } from "../../utils/directRecommendQuery";

const parseSavedLibrary = (parsedLibrary: string | null) => {
  if (!parsedLibrary) return null;

  try {
    return JSON.parse(parsedLibrary);
  } catch (error) {
    window.sessionStorage.removeItem("library");
    return null;
  }
};

export default function RequireLogin({ children }: { children: ReactNode }) {
  const { library } = useParams() as libraryParams;
  const { pathname } = useLocation();

  const parsedLibrary = window.sessionStorage.getItem("library");
  const savedLibrary = parseSavedLibrary(parsedLibrary);
  const normalizedCurrentLibrary = normalizeLibraryCode(library);
  const normalizedSavedLibrary = normalizeLibraryCode(savedLibrary);
  const hasSavedRecommendData = !!window.sessionStorage.getItem("data");
  const shouldAllowDirectRecommend = !!getInitialDirectRecommendAttempt(library, pathname);

  if (
    !shouldAllowDirectRecommend &&
    (!normalizedCurrentLibrary ||
      normalizedSavedLibrary !== normalizedCurrentLibrary ||
      !hasSavedRecommendData)
  ) {
    return <Navigate to={`/${normalizedCurrentLibrary ?? library}/login`} />;
  }
  return <>{children}</>;
}
